import { Component, HostBinding } from '@angular/core';

import { PaymentFlow } from '@fcom/common-booking';
@Component({
  selector: 'fin-mmb-ancillary-purchase-checkout-route',
  templateUrl: './ancillary-purchase-checkout-route.component.html',
  standalone: false,
})
export class AncillaryPurchaseCheckoutRouteComponent {
  @HostBinding('class') classAttribute = 'col-f md-col-1-12';

  readonly paymentFlow = PaymentFlow.MANAGE_BOOKING;
}
